export const categories = [
  {
    svgSource: "TutorialDark.png",
    link: "",
    title: "Tutorials & Courses",
    techCategory: "tutorial",
  },
];
